const zIndices = {
  overlay: 1100,
  drawer: 1200,
  popover: 1300,
  tooltip: 1400,
  modal: 1500,
  toast: 1600,
};

export default zIndices;
